import { NBMap as Map } from './map';
import * as MaplibreGL from 'maplibre-gl';
import { DirectionsService, DistanceMatrixService, SnapToRoadsService, NavigationService, OptimizationMvrpService, } from './api/index';
export default Object.assign(Object.assign({}, MaplibreGL), { NavigationService,
    OptimizationMvrpService,
    DirectionsService,
    DistanceMatrixService,
    SnapToRoadsService,
    Map });
//# sourceMappingURL=index.js.map